import { render, staticRenderFns } from "./NewGuiji.vue?vue&type=template&id=558c0fbe&scoped=true&"
import script from "./NewGuiji.vue?vue&type=script&lang=js&"
export * from "./NewGuiji.vue?vue&type=script&lang=js&"
import style0 from "./NewGuiji.vue?vue&type=style&index=0&id=558c0fbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558c0fbe",
  null
  
)

export default component.exports